import { createContext } from 'react';

// Define the shape of the context value
export default createContext({
  text: "Dodo",
  setText: null,
  menuContent: null,
  setMenuContent: null
});
